module.exports = __webpack_public_path__ + "static/media/BH.6fe69759.png";